import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../../Base';
import { SrOnly } from '../../Helper';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var stylesDefault = {
  "root": "Radio-root_LKnY5",
  "trigger": "Radio-trigger_htv0u",
  "label": "Radio-label_3thFS",
  "disabled": "Radio-disabled_1IL5B"
};
var stylesBlock = {
  "root": "RadioBlock-root_3XTj7 Widget-widget__NYoi Widget-base_2xffH Widget-widgetFluidHeight_3_KT_ Widget-widgetFixedWidth_aNuHK Widget-borderedRight_3Px72",
  "trigger": "RadioBlock-trigger_2zOmF",
  "label": "RadioBlock-label_3Pfaq",
  "disabled": "RadioBlock-disabled_UvCjf"
};
function Radio({
  id,
  name,
  value,
  defaultChecked,
  checked,
  disabled,
  className,
  classes = {},
  children,
  variant = 'default',
  inputProps,
  onChange,
  ...extraProps
}) {
  const classOf = key => classes[key] || '';
  const hideLabel = /compact|block/.test(variant);
  const styles = variant === 'block' ? stylesBlock : stylesDefault;
  const rootClasses = clsx(styles.root, disabled && styles.disabled, className, classOf('root'));
  const triggerClasses = clsx(styles.trigger, classOf('trigger'));
  const labelClasses = clsx(styles.label, classOf('label'));
  return /*#__PURE__*/_jsxs(Base, {
    flex: true,
    gap: variant === 'default' ? 'spacing-2x' : undefined,
    position: "relative",
    className: rootClasses,
    ...extraProps,
    children: [/*#__PURE__*/_jsx("input", {
      type: "radio",
      id: id,
      name: name,
      value: value,
      defaultChecked: defaultChecked,
      checked: checked,
      disabled: disabled,
      className: triggerClasses,
      onChange: onChange,
      ...inputProps
    }), /*#__PURE__*/_jsx(Base, {
      tagName: "label",
      weight: "regular",
      className: labelClasses,
      htmlFor: id,
      children: hideLabel ? /*#__PURE__*/_jsx(SrOnly, {
        children: children
      }) : children
    })]
  });
}
export default Radio;